import * as _ from 'lodash';

import IZoneType = ZoneIQCalibration.IZoneType;

export class ZoneTypeModel implements IZoneType {
    public Id: number;
    public RevisionId: number;
    public ZoningCodeId: number;
    public Name: string;
    public Alias: string;
    public CloneId: number;

    constructor(data: IZoneType) {
        Object.assign(this, _.pick(data, ['Id', 'RevisionId', 'ZoningCodeId', 'Name', 'Alias', 'CloneId']));
    }

    static factory(data: IZoneType) {
        return new ZoneTypeModel(data);
    }
}
